export const INDENTIFICACAOCERTIFICADORA = {
  1: 'QCERTIFICA',
  2: 'CRDC'
};
